// const base = 0;
const above = 1;

// IMPORTANT: when modifying a z-index, check the line above and below to fix the relationships
// always use 'above' to specify relationship
// avoid ambiguity such as b = above + a; c = above + a;

const sidebar = 900;
const drawer = 900;
const popover = above + sidebar;
export const Z = {
	sidebar,
	popover,
	drawer
};

// // CONTENT LAYER
// const contentLayerStart = above + base;
// const contentBackground = above + contentLayerStart;
// const contentText = above + contentBackground;
// const contentImage = above + contentText;
// const contentButton = above + contentImage;
// const contentHeader = above + contentButton;
// const contentHeaderButton = above + contentHeader;
// const contentLayerEnd = above + contentHeaderButton;

// // TOPBAR LAYER
// const topbarLayerStart = above + contentLayerEnd;
// const topbarBackground = above + topbarLayerStart;
// const topbarButtons = above + topbarBackground;
// const topbarSearchBar = above + topbarButtons;
// const topbarSearchBarDeleteButton = above + topbarSearchBar;
// const topbarLayerEnd = above + topbarSearchBarDeleteButton;

// // SIDEBAR LAYER
// const sidebarLayerStart = above + topbarLayerEnd;
// const sidebarBackground = above + sidebarLayerStart;
// const sidebarLinks = above + sidebarBackground;
// const sidebarLogo = above + sidebarLinks;
// const sidebarCollapseButton = above + sidebarLogo;
// const sidebarLayerEnd = above + sidebarCollapseButton;

// // POPUP LAYER
// const popupLayerStart = above + sidebarLayerEnd;
// const popupBackground = above + popupLayerStart;
// const popupContent = above + popupBackground;
// const popupLayerEnd = above + popupContent;
